import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import * as React from "react";
import { UitkLayoutGrid, UitkLayoutGridColumnRow } from "uitk-react-layout-grid";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { EditorialFlexModule } from "../../../../../../typings/microserviceModels/content-flex-module";
import { decorateEditorialHtml } from "../../../ContentUtilities";
import { ConfidenceMsgGridItem } from "../items/ConfidenceMsgGridItem";

const gridColumns = {
  extra_large: 4 as UitkLayoutGridColumnRow,
  large: 4 as UitkLayoutGridColumnRow,
  medium: 2 as UitkLayoutGridColumnRow,
};

export const ConfidenceMsgGridEditorial = ({
  model,
  confidenceMsgClassName,
}: {
  model: EditorialFlexModule;
  confidenceMsgClassName: string;
}) => {
  const { items, boxType } = model;

  if (items.length !== 4) {
    return null;
  }

  const keyHelper = new ItemKeyHelper("editorial");

  return (
    <div data-testid="confidence-msg-grid-editorial">
      <UitkLayoutGrid columns={gridColumns} space="three" alignItems="center" className={confidenceMsgClassName}>
        {items.map((item) => {
          const __html = decorateEditorialHtml(item.text);
          const [icon, title, content] = __html.__html.split("<br />");

          return (
            <>
              <UitkLayoutFlex direction="column" alignContent="center" blockSize="full_size">
                <UitkLayoutFlexItem key={keyHelper.next()} alignSelf="center">
                  <div data-fm-content={item.id}>
                    <ConfidenceMsgGridItem
                      id={model.id}
                      text={{ __html: icon || "" }}
                      boxType={boxType}
                      weight={!content ? "bold" : undefined}
                    />
                  </div>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem key={keyHelper.next()}>
                  <div data-fm-content={item.id}>
                    <ConfidenceMsgGridItem
                      id={model.id}
                      text={{ __html: title || "" }}
                      boxType={boxType}
                      weight={content ? "bold" : "regular"}
                    />
                    <ConfidenceMsgGridItem
                      id={model.id}
                      text={{ __html: content || "" }}
                      boxType={boxType}
                      weight="regular"
                    />
                  </div>
                </UitkLayoutFlexItem>
              </UitkLayoutFlex>
            </>
          );
        })}
      </UitkLayoutGrid>
    </div>
  );
};
